// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3091":"8019ca2b","3167":"8019ca2b","5522":"8019ca2b","5729":"8019ca2b","6517":"31313724","7540":"93d2c7a4","7548":"8019ca2b"}[chunkId] + ".chunk.css";
};